<template>
  <label>
    <span class="label-text">{{ label }}</span>
    <input v-model.number="vModel" :min="min" type="number" />
  </label>
</template>

<script>
export default {
  name: 'BookingFormGuestsElement',
  props: {
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    value: {
      type: [Number, String],
    },
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

label,
input {
  width: 100%;
}

label,
.label-text {
  display: block;
}

label {
  margin-bottom: 0;
}

.label-text {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;

  @media (min-width: vars.$tablet-break-point) {
    font-size: 14px;
  }
}

input {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  color: vars.$c-dark-gray;
  border: 1px solid vars.$c-gray-a2;

  &::placeholder {
    color: vars.$c-gray-a2;
  }

  @media (min-width: vars.$tablet-break-point) {
    font-size: 15px;
  }
}
</style>
